import { reportCurrency, type SiteComparisonRow, type SiteMoneyBucket } from '@evi/shared';

export function filterComparisonRows(rows: SiteComparisonRow[], ids: string[]): SiteComparisonRow[] {
  return ids.length ? rows.filter((row) => ids.includes(row.location_id)) : rows;
}

export function comparisonTotals(rows: SiteComparisonRow[]) {
  const money = new Map<string | null, SiteMoneyBucket>();
  for (const row of rows) for (const bucket of row.money_by_currency) {
    const currency = reportCurrency(bucket.currency);
    const total = money.get(currency) ?? { currency, collected_sales_cents: currency ? 0 : null,
      electricity_cost_cents: currency ? 0 : null, held_electricity_cents: currency ? 0 : null };
    for (const key of ['collected_sales_cents', 'electricity_cost_cents', 'held_electricity_cents'] as const) {
      total[key] = total[key] == null || bucket[key] == null ? null : total[key] + bucket[key];
    }
    money.set(currency, total);
  }
  return { ...rows.reduce((sum, row) => ({
    charger_count: sum.charger_count + row.charger_count,
    online_count: sum.online_count + row.online_count,
    sessions: sum.sessions + row.sessions,
    energy_kwh: sum.energy_kwh + row.energy_kwh,
  }), { charger_count: 0, online_count: 0, sessions: 0, energy_kwh: 0 }),
  money_by_currency: [...money.values()].sort((a, b) => (a.currency ?? '').localeCompare(b.currency ?? '')) };
}

/** One financial row per currency. Activity counts appear once per location. */
export function comparisonCsvRows(rows: SiteComparisonRow[], financial: boolean): unknown[][] {
  return rows.flatMap(r => {
    const activity = [r.charger_count, r.online_count, r.sessions, r.energy_kwh];
    if (!financial) return [[r.name, ...activity]];
    const buckets = r.money_by_currency.length ? r.money_by_currency : [{ currency: null,
      collected_sales_cents: null, electricity_cost_cents: null, held_electricity_cents: null }];
    return buckets.map((b, i) => [r.name, ...(i ? ['', '', '', ''] : activity), b.currency ?? 'Not recorded',
      ...[b.collected_sales_cents, b.electricity_cost_cents, b.held_electricity_cents].map(c => c == null ? '' : c / 100)]);
  });
}
